import * as React from 'react';
import PropTypes from 'prop-types';

export const WordHighLighter = ({ text, highlightText, styles }) => {
  let customStyle = styles;
  if (typeof customStyle !== 'object' || customStyle === null) customStyle = {};
  if (highlightText === '') {
    return <span style={{ ...customStyle }}>{text}</span>;
  }
  let chunks = [];
  try {
    RegExp.quote = function (str) {
      return str.replace(/([.?*+^$[\]\\(){}|-])/g, '\\$1');
    };
    chunks = text.split(new RegExp(`(${RegExp.quote(highlightText)})`, 'gi'));
  } catch (e) {
    return <span style={{ ...customStyle }}>{text}</span>;
  }
  return (
    <span style={{ ...customStyle }}>
      {chunks.map((s, i) =>
        s.toLowerCase() === highlightText.toLowerCase() ? (
          <mark className="keyword" key={`highlighter-${i}`}>
            {s}
          </mark>
        ) : (
          <React.Fragment key={`highlighter-${i}`}>{s}</React.Fragment>
        ),
      )}
    </span>
  );
};

WordHighLighter.propTypes = {
  text: PropTypes.string,
  highlightText: PropTypes.string,
};

WordHighLighter.defaultProps = {
  text: '',
  highlightText: '',
  styles: {},
};
